import { onAnimationEnd } from '@theme/utilities';
// Use native theme navigation and drawer behavior, while keeping PDP anchors on-page.
document.addEventListener('click',event=>{
 if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
 const link=event.target.closest?.('#header-group a[href]');
 if(!link||link.target==='_blank')return;
 const url=new URL(link.href,location.href);
 if(url.origin!==location.origin||!url.hash)return;
 if(url.pathname!==location.pathname&&url.pathname!=='/')return;
 let id;try{id=decodeURIComponent(url.hash.slice(1));}catch{return;}
 const target=document.getElementById(id);if(!target)return;
 event.preventDefault();
 const jump=()=>{history.pushState(null,'',url.hash);target.setAttribute('tabindex','-1');target.focus({preventScroll:true});target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});};
 const drawer=link.closest('header-drawer');
 if(drawer?.isOpen){const panel=drawer.querySelector('[ref="menuDrawer"]');drawer.close();if(panel)onAnimationEnd(panel,jump,{subtree:false});else jump();}
 else jump();
});
